import type { Viewport } from './ir.js';

// THE VIEWPORT MATRIX. Every fixture is laid out against every cell, on every renderer.
// `font_scale` is where the customer bug reports come from.
export const VIEWPORTS: Viewport[] = [
  { w: 390, h: 844, color_scheme: 'light', font_scale: 1.0 },
  { w: 390, h: 844, color_scheme: 'dark', font_scale: 1.0 },
  { w: 390, h: 844, color_scheme: 'light', font_scale: 1.5 },
  { w: 390, h: 844, color_scheme: 'light', font_scale: 1.0, direction: 'rtl' },
  // font_scale 2.0 against a max_scale of 1.6 MUST clamp. The clamp is invisible in frames
  // alone; `resolved.font_size` is what pins it.
  { w: 390, h: 844, color_scheme: 'light', font_scale: 2.0 },
];

// `direction` MUST be in the key. Without it the RTL snapshot silently overwrites the LTR one
// at the same size/scheme/scale, and the comparator comes up green having compared a file with
// itself. (That bug was real; it is why RTL went unexercised for two commits.)
export const vpKey = (v: Viewport): string =>
  `${v.w}x${v.h}_${v.color_scheme}_fs${v.font_scale}${v.direction === 'rtl' ? '_rtl' : ''}`;
